import UltMeta, { Meta } from "@/meta/UltMeta/index";

/**
 * 预警异常类型
 */
class ExceptionType extends UltMeta {
    DEVICE = new Meta(1, "设备异常");
    SHIP = new Meta(2, "船舶异常");
}

export const EXCEPTION_TYPE = new ExceptionType();

class HandleState extends UltMeta {
    UNHANDLED = new Meta(1, "未处理");
    HANDLED = new Meta(2, "已处理");
}

export const HANDLE_STATE = new HandleState();

class RecognizeResult extends UltMeta {
    LOADING = new Meta(0, "装载中");
    UNLOADING = new Meta(1, "卸货中");
    LOADED = new Meta(2, "满载");
    IDLE = new Meta(3, "空载");
    UNKNOWN = new Meta(4, "未知");
}

export const RECOGNIZE_RESULT = new RecognizeResult();
